import React from 'react';
import { useAuth } from 'api';
import { Loading } from 'ui';
import Login from './Login';
import Logout from './Logout';
import InviteNotFound from './InviteNotFound';
import AcceptInvite from './AcceptInvite';
import SendPasswordReset from './SendPasswordReset';
import PasswordResetSent from './PasswordResetSent';
import ResetPassword from './ResetPassword';
import Register from './Register';
import VerifyEmail from './VerifyEmail';
import EmailVerified from './EmailVerified';
import Plan from './Plan';
import Billing from './Billing';
import Company from './Company';
import { Redirect, Switch, Route, useRouteMatch } from "react-router-dom";
import queryString from 'query-string';
import './index.css';


export default function Auth(props) {
  
  const auth = useAuth();
  const match = useRouteMatch();

  if(auth === null) {
    return <Loading/>;
  }

  return (
    <Switch>
      <Route path={`${match.path}/login`} component={Login}/>
      <Route path={`${match.path}/logout`} component={Logout}/>
      <Route path={`${match.path}/invite/:inviteId`} component={AcceptInvite}/>
      <Route path={`${match.path}/invite-not-found`} component={InviteNotFound}/>
      <Route path={`${match.path}/send-password-reset`} component={SendPasswordReset}/>
      <Route path={`${match.path}/password-reset-sent`} component={PasswordResetSent}/>
      <Route path={`${match.path}/reset-password`} component={ResetPassword}/>
      <Route path={`${match.path}/register`} component={Register}/>
      <Route path={`${match.path}/verify-email`} component={VerifyEmail}/>
      <Route path={`${match.path}/email-verified`} component={EmailVerified}/>
      <Route path={`${match.path}/plan`} component={Plan}/>
      <Route path={`${match.path}/company`} component={Company}/>
      <Route path={`${match.path}/billing`} component={Billing}/>
      <Route render={({location}) => {
        const {mode} = queryString.parse(location.search)
        if(mode === 'resetPassword') {
          return <Redirect to={`${match.url}/reset-password${location.search}`}/>;
        }
        if(mode === 'verifyEmail') {
          return <Redirect to={`${match.url}/email-verified${location.search}`}/>;
        }
        return <Redirect to={`${match.url}/login`}/>;
      }}/>
    </Switch>
  );
}
